import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countryCode", "taxIdField"]

  displayTaxIdField() {
    // If the country isn't India, we hide the Tax ID input.
    if (this.countryCodeTarget.value !== "IN") {
      this.taxIdFieldTarget.classList.add("d-none")
      return
    }

    this.taxIdFieldTarget.classList.remove("d-none")
  }
}
